export const SWIFT_CODE_REGEX = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const normalizeSwiftCode = (swiftCode: string): string => swiftCode.toUpperCase().trim();

export const isValidSwiftCode = (swiftCode: string): boolean =>
  SWIFT_CODE_REGEX.test(normalizeSwiftCode(swiftCode));

export const swiftBic8 = (swiftCode: string): string => normalizeSwiftCode(swiftCode).slice(0, 8);

const SWIFT_BIC8_OVERRIDES: Readonly<Record<string, string>> = {
  PAGIILIT: 'FIRBILIT',
};

export const remapSwiftCode = (swiftCode: string): string => {
  const normalized = normalizeSwiftCode(swiftCode);
  const override = SWIFT_BIC8_OVERRIDES[normalized.slice(0, 8)];
  return override ? override + normalized.slice(8) : normalized;
};

// A SWIFT BIC's positions 5-6 (1-indexed) are the ISO country code of the bank.
// "BOFAUS3N" → "US" → US bank. We use this to trigger the SWIFT-to-WIRE morph
// instead of trusting the customer-supplied bankAddress.country, which can be
// (and historically has been) forged to bypass our US-bank gate.
export const isUsBic = (swiftCode: string): boolean => {
  const normalized = normalizeSwiftCode(swiftCode);
  return normalized.length >= 6 && normalized.substring(4, 6) === 'US';
};
